export default [{
        name: "ackee-report",
        github: "BetaHuhn/ackee-report",
        description: {
            de: "CLI tool zum Generieren von Leistungsberichten von Webseiten mit dem analytics tool Ackee.",
            en: "CLI tool to generate performance reports of websites using the self-hosted analytics tool Ackee."
        },
        language: "JavaScript • NPM"
    },
    {
        name: "drkmd.js",
        demo: "https://codepen.io/BetaHuhn/pen/oNxdBzK",
        github: "BetaHuhn/drkmd.js",
        description: {
            de: "Einfache Bibliothek zur Integration einer Dark-Mode- / Light-Mode-Logik in jede Webseite.",
            en: "Simple library to integrate a dark-mode/light-mode logic with any website."
        },
        language: "JavaScript • CSS • NPM"
    },
    {
        name: "feedback-js",
        demo: "https://codepen.io/BetaHuhn/pen/MWebeXp",
        github: "BetaHuhn/feedback-js",
        description: {
            de: "Einfaches modernes Feedback-Modal für jede Webseite.",
            en: "Simple modern feedback modal for any website."
        },
        language: "JavaScript • CSS • NPM"
    },
    {
        name: "qrgen.cc",
        demo: "https://qrgen.cc",
        github: "BetaHuhn/qrgen",
        description: {
            de: "QrGenc.cc ist ein service mit dem man einfach und schnell QR-Codes und kurz-URLs erstellen kann",
            en: "QrGen.cc is a free service that lets you create QR-Codes and shortened URLs from any link quickly and easily"
        },
        language: "Vue.js • Node.js"
    },
    {
        name: "ejs-serve",
        github: "BetaHuhn/ejs-serve",
        description: {
            de: "NPM-Paket zum Erstellen, Überwachen und Bereitstellen von EJS-Templates während der Entwicklung im Browser.",
            en: "NPM package to build, watch and serve your EJS templates during development in your browser."
        },
        language: "Node.js • NPM"
    },
    {
        name: "spaces-cli",
        github: "BetaHuhn/spaces-cli",
        description: {
            de: "CLI-Tool zum schnellen und einfachen Hoch- und Herunterladen von Dateien aus DigitalOcean Spaces.",
            en: "CLI tool to quickly upload and download files from DigitalOcean Spaces."
        },
        language: "Node.js • NPM"
    },
    {
        name: "running-at",
        github: "BetaHuhn/running-at",
        description: {
            de: "NPM-Paket zum Abrufen/Ausgeben der Lokalen- und Netzwerk-IP-Adresse.",
            en: "NPM package to get/print your local and network IP address."
        },
        language: "Node.js • NPM"
    },
    {
        name: "repo-file-sync-action",
        github: "BetaHuhn/repo-file-sync-action",
        description: {
            de: "GitHub Action, um Dateien wie Action-Workflows oder ganze Verzeichnisse zwischen mehreren Repositorys zu synchronisieren.",
            en: "GitHub Action to keep files like Action workflows or entire directories in sync between multiple repositories."
        },
        language: "JavaScript • GitHub Actions"
    },
    {
        name: "metadata-scraper",
        github: "BetaHuhn/metadata-scraper",
        description: {
            de: "NPM-Paket zum Scrapen/Parsen von Metadaten einer Webseite.",
            en: "NPM package for scraping/parsing metadata from a web page."
        },
        language: "JavaScript • NPM"
    },
    {
        name: "Portfolio Website",
        github: "BetaHuhn/portfolio",
        description: {
            de: "Meine Portfolio Webseite (die aktuelle Seite).",
            en: "My portfolio website (the site you are currently viewing)"
        },
        language: "Vue.js"
    },
    {
        name: "MailPal",
        demo: 'https://mailpal.cc',
        description: {
            de: "Du brauchst eine Wegwerf E-Mail-Adresse für eine Website? Du willst nicht der ganzen Welt deine persönliche E-Mail-Adresse mitteilen? Mit diesem Service kannst du schnell und einfach eine temporäre E-Mail-Adresse erstellen. Noch in der Entwicklung.",
            en: "Need a throw away email or don't want to share your personal email with the whole world? MaiPal's email forwarding service let's you create unlimited email aliases."
        },
        language: "Vue.js • Node.js • Haraka"
    },
    {
        name: "Pixel Art Country selector",
        demo: "https://flags.mxis.ch",
        github: "BetaHuhn/countryPicker",
        description: {
            de: "Anstatt dein Land in einem Formular aus einer langen List auszuwählen, male einfach die Flagge.",
            en: "Instead of choosing your country using a dropdown, draw your flag."
        },
        language: "HTML5 • Node.js"
    },
]